import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  isSaving: false,
  error: null,
  data: {
    assetAttributes: [],
    profileAttributes: [],
    weatherAttributes: [],
    filter: {},
    lastSave: {}
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.UPDATE_ATTRIBUTE_FILTER:
      return {
        ...state,
        data: {
          ...state.data,
          filter: action.filter
        }
      };
    case Constants.REQUEST_ATTRIBUTES:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_ATTRIBUTES:
      if (action.error) {
        return {
          ...state,
          isLoading: false,
          error: action.error,
          data: {
            ...state.data,
            lastSave: {
              error: action.error
            }
          }
        };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          assetAttributes: action.data?.attributes?.AssetAttribute || [],
          profileAttributes: action.data?.attributes?.ProfileAttribute || [],
          weatherAttributes: [
            ...(action.data?.attributes?.WeatherTemperatureAttribute || []),
            ...(action.data?.attributes?.WeatherPrecipitationAttribute || []),
            ...(action.data?.attributes?.WeatherAlarmAttribute || []),
            ...(action.data?.attributes?.WeatherIndexAttribute || [])
          ]
        }
      };
    case Constants.REQUEST_SAVE_ATTRIBUTES:
      return { ...state, isSaving: true };
    case Constants.RECEIVE_SAVE_ATTRIBUTES:
      if (action.error) {
        return {
          ...state,
          isSaving: false,
          data: {
            ...state.data,
            lastSave: {
              error: action.error
            }
          }
        };
      }
      return {
        ...state,
        isSaving: false,
        data: {
          ...state.data,
          lastSave: {
            mode: action.mode,
            attribute: { ...action.data, ...action.attribute }
          }
        }
      };
    default:
      return state;
  }
}
